import { TipDetail, WorkDay } from '@core/models';
import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { TipCalculationFactory } from './tip-calculation-factory.service';

export class TipCalculationProcessor {
	constructor(private readonly factory: TipCalculationFactory) {}

	calculateAmount(
		tip: TipDetail | null,
		subtotal: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): bigint {
		if (!tip) {
			return 0n;
		}

		return this.factory.create(tip).calculateAmount(tip, subtotal, precisionService, workDay);
	}

	calculateOptions(
		tips: readonly TipDetail[],
		subtotal: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): TipDetail[] {
		return tips.map(tip =>
			this.factory.create(tip).calculateOption(tip, subtotal, precisionService, workDay)
		);
	}
}

export const tipCalculationProcessor = new TipCalculationProcessor(new TipCalculationFactory());
